export default __webpack_public_path__ + "static/media/888511943579680809.09f18fab.gif";